// Trigger a browser save of an in-memory Blob under a chosen filename.
// For bytes assembled in the browser (a merged PDF, a generated report)
// — a document already reachable at a server URL should link there
// directly instead (see DocumentsTab's plain download href).

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  // Appending to the DOM before clicking makes the download fire across
  // browsers (notably Firefox).
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the download has a chance to start.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
